/*
  Input Text
*/

import React from "react";

// Antd
import { Form, Button } from "antd";

// Style
import "./style.scss";

function InputButton({
  name,
  type,
  label,
  onClick,
  disabled,
  className,
  notwrapInForm,
  htmlType,
  loading,
  children,
  danger,
  icon,
}) {
  // Input Text
  const InputButton = (
    <Button
      type={type}
      className={className}
      label={label}
      onClick={onClick || null}
      disabled={disabled}
      htmlType={htmlType}
      loading={loading}
      danger={danger}
      icon={icon}
    >
      {children}
    </Button>
  );

  return !!notwrapInForm ? (
    <>{InputButton}</>
  ) : (
    <Form.Item name={name} label={label}>
      {InputButton}
    </Form.Item>
  );
}

export default InputButton;
